import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {GenerateCreditNoteConfirmationComponent} from '../generate-credit-note-confirmation/generate-credit-note-confirmation.component'
@Component({
  selector: 'app-details-note-credit-transacction',
  templateUrl: './details-note-credit-transacction.component.html',
  styleUrls: ['./details-note-credit-transacction.component.scss']
})
export class DetailsNoteCreditTransacctionComponent implements OnInit {

  otherRef?: BsModalRef;

  constructor(private modalsSvc: BsModalService) { }

  ngOnInit(): void { 

    if(this.otherRef){
      this.otherRef.hide();
    }
    
  }

  close(){
    this.modalsSvc.hide();
  }
}
